import * as React from "react";
const SvgFiRrSortAlphaUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 22h-3.84s4.521-5.065 4.552-5.114A1.884 1.884 0 0 0 20.113 14h-4.112a1 1 0 1 0 0 2h3.84s-4.52 5.065-4.552 5.114A1.884 1.884 0 0 0 16.89 24H21a1 1 0 1 0 0-2m1-18.5V9a1 1 0 1 1-2 0V7h-3v2a1 1 0 1 1-2 0V3.5C15 1.57 16.57 0 18.5 0S22 1.57 22 3.5M20 5V3.5c0-.827-.673-1.5-1.5-1.5S17 2.673 17 3.5V5zm-8.293 1.293a1 1 0 0 0 0-1.414L7.414.586A2 2 0 0 0 6 0c-.512 0-1.024.195-1.414.585L.293 4.879a.999.999 0 1 0 1.414 1.414L5 3v20a1 1 0 1 0 2 0V3l3.293 3.293a1 1 0 0 0 1.414 0"
    />
  </svg>
);
export default SvgFiRrSortAlphaUp;
